import forEach from 'lodash-es/forEach';
import lowerFirst from 'lodash-es/lowerFirst';
import pickBy from 'lodash-es/pickBy';
import omitBy from 'lodash-es/omitBy';
import mapKeys from 'lodash-es/mapKeys';
import isFunction from 'lodash-es/isFunction';

export var getEventHandlerProps = function getEventHandlerProps(props) {
  return pickBy(props, _isEventKey);
};

export var getNonEventHandlerProps = function getNonEventHandlerProps(props) {
  return omitBy(props, _isEventKey);
};

export var getEventsConfig = function getEventsConfig(props) {
  var eventProps = getEventHandlerProps(props);

  return mapKeys(eventProps, function (handler, eventName) {
    return lowerFirst(eventName.replace(/^on/, ''));
  });
};

export var addEventHandlersManually = function addEventHandlersManually(Highcharts, context, props) {
  var eventProps = getEventsConfig(props);

  forEach(eventProps, function (handler, eventName) {
    Highcharts.addEvent(context, eventName, handler);
  });
};

export var addEventHandlers = function addEventHandlers(updateFn, props) {
  var events = getEventsConfig(props);
  updateFn({ events: events });
};

var _isEventKey = function _isEventKey(value, key) {
  return key.indexOf('on') === 0 && isFunction(value);
};

export default addEventHandlers;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jsx-highcharts/dist/es/utils/events.js
// module id = 86
// module chunks = 0